import { DISCOVER } from "constants/types";
import qs from "query-string";


const initState = {
	search: "",
	category: null,
	shop: null,
	shopID: null,
	price: [],
	gateway: [],
	currency: [],
	created: [],
	score: "",
	sort: "",
};

export const updateURL = (state, value, history, isClear) => {

	if(history) {
		let search = state ? `?${qs.stringify({
			search: state.search,
			category: state.category,
			price: state.price.join(','),
			gateway: state.gateway.join(','),
			currency: state.currency.join(','),
			created: state.created.join(','),
			score: state.score,
			sort: state.sort,
			...value
		})}` : '';

		if(isClear) {
			history.push({
				pathname: `/search`,
				search
			});
		} else {
			history.push({
				search
			});
		}
	}

}


const DiscoverFiltersReducer = (state = initState, action) => {

	const { type, payload, history } = action;

	switch(type) {

		case DISCOVER.INITIAL_FILTERS:

			return {
				...state,
				price: payload.price,
				gateway: payload.gateway,
				currency: payload.currency,
				score: payload.score,
				search: payload.search,
				category: payload.category,
				created: payload.created,
				shop: payload.shop,
				shopID: payload.shopID,
				sort: payload.sort,
			}

		case DISCOVER.FILTERS.PRICE:

			let currentPrice = state.price;

			if(state.price.includes(payload)) {
				currentPrice = state.price.filter((v) => v !== payload);
			} else {
				currentPrice.push(payload);
			}

			updateURL(state, {
				price: currentPrice.join(',')
			}, history)

			return {
				...state,
				price: currentPrice,
			}

		case DISCOVER.FILTERS.GATEWAY:

			let currentGateway = state.gateway;

			if(state.gateway.includes(payload)) {
				currentGateway = state.gateway.filter((v) => v !== payload);
			} else {
				currentGateway.push(payload);
			}

			updateURL(state, {
				gateway: currentGateway.join(',')
			}, history)

			return {
				...state,
				gateway: currentGateway,
			}

		case DISCOVER.FILTERS.CURRENCY:

			let currentCurrency = state.currency;

			if(state.currency.includes(payload)) {
				currentCurrency = state.currency.filter((v) => v !== payload);
			} else {
				currentCurrency.push(payload);
			}

			updateURL(state, {
				currency: currentCurrency.join(',')
			}, history)

			return {
				...state,
				currency: currentCurrency,
			}

		case DISCOVER.FILTERS.SCORE:

			updateURL(state, {
				score: payload
			}, history);

			return {
				...state,
				score: payload,
			}


		case DISCOVER.FILTERS.SORT:

			updateURL(state, {
				sort: payload
			}, history);

			return {
				...state,
				sort: payload,
			}

		case DISCOVER.FILTERS.CREATED:

			let currentCreated = state.created;

			if(state.created.includes(payload)) {
				currentCreated = state.created.filter((v) => v !== payload);
			} else {
				currentCreated.push(payload);
			}

			updateURL(state, {
				created: currentCreated.join(',')
			}, history);

			return {
				...state,
				created: currentCreated,
			}

		case DISCOVER.FILTERS.SEARCH:
			return {
				...state,
				search: payload,
			}

		case DISCOVER.FILTERS.CATEGORY:
			return {
				...state,
				category: payload,
			}

		case DISCOVER.FILTERS.SHOP:
			return {
				...state,
				shop: payload,
			}

		case DISCOVER.FILTERS.SHOP_ID:
			return {
				...state,
				shopID: payload,
			}

		case DISCOVER.FILTERS.CLEAR:

			updateURL(null, null, history, true);

			return {
				...initState
			}


		default:
			return state
	}
}

export default DiscoverFiltersReducer;